<div class="flex gap-2 items-center w-full">
	<p [class]="labelClass">Effective date</p>
	<div class="flex flex-1 gap-2">
		<app-date-picker
			[ngModel]="effectiveDate"
			(ngModelChange)="setEffectiveDate($event)"
			[testHook]="testHooks.EffectiveDateDatePicker"
		></app-date-picker>
		<!-- this div is intentional -->
		<div class="w-5"></div>
	</div>
</div>
